import React from 'react';
import { Dialog, DialogContent } from '@/Components/shadcn/dialog';
import { cn } from '@/lib/utils';
import AssessmentResetDialogHeader from './AssessmentResetDialogHeader';
import AssessmentResetDialogBody from './AssessmentResetDialogBody';
import AssessmentResetDialogActions from './AssessmentResetDialogActions';

export interface AssessmentResetDialogProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    onConfirm: () => Promise<void>;
}

const AssessmentResetDialog = ({ open, setOpen, onConfirm }: AssessmentResetDialogProps): React.JSX.Element => {
    return (
        <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && setOpen(false)}>
            <DialogContent showCloseButton={false} className={cn('flex max-w-lg flex-col gap-4 p-6 sm:max-w-lg')}>
                <AssessmentResetDialogHeader />
                <AssessmentResetDialogBody />
                <AssessmentResetDialogActions onCancel={() => setOpen(false)} onConfirm={onConfirm} />
            </DialogContent>
        </Dialog>
    );
};

export default AssessmentResetDialog;
